import { type BundleNode, isDecisionNode, isManagedNode, isRulesNode, isTaskNode } from './types';

const producedKeys = (node: BundleNode): string[] => {
  if (isRulesNode(node)) return [node.key];
  if (isDecisionNode(node)) return node.questions.map(question => question.key);
  const task = isManagedNode(node) ? node.task : node;
  // A report is a file, not readable as `outputs.<key>`, so it can't stand in for an input.
  return isTaskNode(task) ? task.fields.map(field => field.name) : [];
};

const nodesAboveRules = (nodes: BundleNode[]): BundleNode[] => {
  const firstRules = nodes.findIndex(isRulesNode);
  return firstRules === -1 ? nodes : nodes.slice(0, firstRules);
};

/**
 * A catalog task lands above the first rules node, so a rule already in the plan can read what it
 * produces. The backend inserts after this parent, or at the head when there is none.
 */
const catalogParentId = (nodes: BundleNode[]): string | undefined => nodesAboveRules(nodes).at(-1)?.id;

/** What the nodes above the landing spot produce: an input with one of these names is read from them. */
const keysProducedAbove = (nodes: BundleNode[]): Set<string> => new Set(nodesAboveRules(nodes).flatMap(producedKeys));

export { catalogParentId, keysProducedAbove };
